import Backbone from 'backbone'
import sections from 'scoreboard/components/sections'
import globals from 'scoreboard/components/globals'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'

/**
 * Used to create a shared dashboard as an embeddable resource
 * @type {any}
 */
var SharedDashboard = Backbone.Model.extend({

	section: 'dashboards',

	initialize: function (attr, opt = {}) {
		this.options = opt
	},

	url: function(options) {
		return 'api/' + sections.toUrl(this.section) + '/' + this.get('domainObjectId') + '/shared'
	}
}, {
	/**
	 * @returns {String} the application url to use for drilling down
	 * into dashboard widgets.
	 */
	drilldownUrl: function(route) {
		// #27551 apply the current calendar period, even if the user has
		// to login first (where we normally wipe out the period; #21549)
		return scoreboardUrl(`${route}?periodId=${globals.periodId}`, {
			ignoreToken: true
		})
	}
})

export default SharedDashboard

SharedDashboard.__filename__ = 'dashboards/shared-dashboard.js'
